// extracted by mini-css-extract-plugin
export default {"purchase-title-report":"g__purchase-title-report--oz3gt"};